import { useEventContext } from "../../../context/EventContext/EventContext";
import { Col, Row } from "antd";
import { EventPreviewLocalizableFormData, EventTextRules } from "../../../context/EventContext/constants";
import InputComponent from "../../../components/InputComponent";
import TextareaComponent from "../../../components/TextareaComponent";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import { PreviewImageUpload, PreviewTextConstants } from "./constants";
import { CultureProps } from "../constants";

const EventPreviewDetail = ({ Culture }: CultureProps) => {
	const { eventForm, setEventForm } = useEventContext();
	const fields = PreviewTextConstants[Culture];

	const localized = eventForm.eventPreview.eventPreviewLocalizable.find(x => x.culture === Culture);

	const handleChange = <K extends keyof EventPreviewLocalizableFormData>(key: K, value: EventPreviewLocalizableFormData[K]) => {
		setEventForm(prev => ({
			...prev,
			eventPreview: {
				...prev.eventPreview,
				eventPreviewLocalizable: prev.eventPreview.eventPreviewLocalizable.map(item =>
					item.culture === Culture ? { ...item, [key]: value } : item
				),
			},
		}));
	};

	return (
		<>
			<Row gutter={[20, 20]}>
				<Col xs={24} sm={24} md={12} lg={12}>
					<InputComponent
						title={fields.header.label}
						isRequired
						placeholder={fields.header.placeholder}
						value={localized?.header}
						maxLength={EventTextRules.previewHeaderMaxLength}
						onChange={e => handleChange("header", e.target.value)}
					/>
					<TextareaComponent
						title={fields.previewText.label}
						isRequired
						placeholder={fields.previewText.placeholder}
						rows={10}
						resizable={false}
						value={localized?.previewText}
						limitCharacter={EventTextRules.previewTextMaxLength}
						lineBreaks={EventTextRules.lineBreaks}
						onChange={e => handleChange("previewText", e.target.value)}
					/>
				</Col>
				<Col xs={24} sm={24} md={12} lg={12}>
					<FileUploadComponent
						title={fields.image.label}
						isRequired
						maxFileSize={PreviewImageUpload.maxFileSize}
						dimensions={PreviewImageUpload.dimensions}
						allowedExtensions={PreviewImageUpload.extensions}
						onChange={(files: FileData[] | null) => handleChange("image", files?.[0]?.file ?? null)}
						style={{ minHeight: "400px" }}
					/>
				</Col>
			</Row>
		</>
	);
};

export default EventPreviewDetail;
